import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-date-later-than-now",
  templateUrl: "./field-set-date-later-than-now.component.html",
  styles: [],
})
export class FieldSetDateLaterThanNowComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
